import { useEffect, useState } from "react";

const useIsNightOrEarly = () => {
  const [isNightOrEarly, setIsNightOrEarly] = useState<boolean>(false);

  const checkTime = () => {
    const now = new Date();
    const hour = now.getHours();
    // 오전 0시 ~ 9시(포함): true
    // 오후 8시(20시) ~ 23시: true
    setIsNightOrEarly(hour < 10 || hour >= 20);
  };

  useEffect(() => {
    checkTime(); // 초기 체크

    const interval = setInterval(() => {
      checkTime();
    }, 60 * 1000); // 1분마다 갱신

    return () => clearInterval(interval); // 언마운트 시 정리
  }, []);

  return isNightOrEarly;
};

export default useIsNightOrEarly;
